module.exports = __webpack_public_path__ + "static/media/arbitration.4d6e0473.png";